'use strict'
import { partition } from 'lodash';

import { loadComponent } from './utils/load-component';
import { getPurchasedDigitalConcerts } from '../services/digital-inventory';
import { initialiseElement as initScrollerElement } from '../modules/scroller';
import { getPackages } from '../services/package';

const modeOfSale = 6;
const source = 1;

loadComponent('your-purchases', {
    data() {
        return {
            ViewModel: {
                Loading: true,
                TotalItems: 0,
                Subscriptions: [],
                Events: [],
            },
        }
    },

    mounted() {
        getPurchasedDigitalConcerts().then(response => {
            const [ packagePerformances, singlePerformances ] = partition(response, item => {
                return parseInt(item.package_no, 10);
            });

            const packagePromise = getPackages(modeOfSale, source).then(response => {
                const packageNumbers = packagePerformances.map(item => {
                    return parseInt(item.package_no, 10);
                });

                return response.filter(item => {
                    return packageNumbers.indexOf(parseInt(item.PackageNumber, 10)) !== -1;
                });
            }).catch(error => {
                console.error(error);
                return [];
            });

            const singlePerformancePromise = Promise.resolve(singlePerformances);

            return Promise.all([ packagePromise, singlePerformancePromise ]);
        }).then(items => {
            this.ViewModel.Subscriptions = items[0];
            this.ViewModel.Events = items[1];

            this.ViewModel.TotalItems = this.ViewModel.Subscriptions.length + this.ViewModel.Events.length;

            this.ViewModel.Loading = false;

            this.$nextTick(() => {
                if (this.$refs.jsScroller) {
                    initScrollerElement(this.$refs.jsScroller);
                }
            });
        });
    },
});
